// user.service.ts
import { Injectable }                           from '@angular/core';
import { Http, Headers, Response, 
         URLSearchParams, ResponseContentType } from '@angular/http';
import { User, Student, Team, 
         Event, Survey, Question,Leader, Season }              from '../_models/index';

import {Observable}                             from 'rxjs/Rx';
import { StorageService}                        from './storage.service';
import { environment } from '../../environments/environment';
import * as moment                                 from 'moment';

class StudentItem {
  constructor(
    public first_name: string,
    public last_name: string,
    public user_id: string,
    public id: string,
    public team: string,
    public email: string,
    public first_last_name:string,
    public miles_run:Object
  ) {}
}
class FamilyItem {
  constructor(
    public first_name: string,
    public last_name: string,
    public id: string,
    public team_name: string,
    public email: string,
    public first_last_name:string
  ) {}
}

@Injectable()
export class APIService {
  public progressObserver;
  public progress;
  public progress$;
  public dismiss;
  
  // private baseUrl: string = 'http://srp.curotec.net/api/public/api/v1/';
  // public  invitationUrl: string = 'http://srp.curotec.net/frontend/dist/#/register/';
  // public  invitationLeaderUrl: string = 'http://srp.curotec.net/frontend/dist/#/leader-register/';
  private baseUrl: string = '';
  public  invitationUrl: string = '';
  public  invitationLeaderUrl: string = '';
  //public  invitationUrl: string = 'http://localhost:4200/#/register/';

  constructor(private http : Http, private storage: StorageService){
    this.baseUrl = environment.baseUrl;
    this.invitationUrl = environment.invitationUrl;
    this.invitationLeaderUrl = environment.invitationLeaderUrl;

    this.progress = Observable.create(observer => {
        this.progressObserver = observer
    }).share();

    this.progress$ = Observable.create(observer => {
        this.progressObserver = observer
    }).share();
  }
  public getShirtJacketSize(){
    let arr = [{
      key : 'XS',
      value : 'XS'
    },{
      key : 'S',
      value : 'S'
    },{
      key : 'M',
      value : 'M'
    },{
      key : 'L',
      value : 'L'
    },{
      key : 'XL',
      value : 'XL'
    },{
      key : '2XL',
      value : '2XL'
    }];
    return arr;
  }
  public getShoeSize(){
    let arr = [{
      key : '2.5',
      value : '2.5'
    },{
      key : '3',
      value : '3'
    },{
      key : '3.5',
      value : '3.5'
    },{
      key : '4',
      value : '4'
    },{
      key : '4.5',
      value : '4.5'
    },{
      key : '5',
      value : '5'
    },{
      key : '5.5',
      value : '5.5'
    },{
      key : '6',
      value : '6'
    },{
      key : '6.5',
      value : '6.5'
    },{
      key : '7',
      value : '7'
    },{
      key : '7.5',
      value : '7.5'
    },{
      key : '8',
      value : '8'
    },{
      key : '8.5',
      value : '8.5'
    },{
      key : '9',
      value : '9'
    },{
      key : '9.5',
      value : '9.5'
    },{
      key : '10',
      value : '10'
    },{
      key : '10.5',
      value : '10.5'
    },{
      key : '11',
      value : '11'
    },{
      key : '11.5',
      value : '11.5'
    },{
      key : '12',
      value : '12'
    },{
      key : '12.5',
      value : '12.5'
    },{
      key : '13',
      value : '13'
    },{
      key : '13.5',
      value : '13.5'
    },{
      key : '14',
      value : '14'
    },{
      key : '15',
      value : '15'
    }];
    return arr;
  }
  public getGrades(){
    let arr = [{
      key : '6',
      value : '6'
    },{
      key : '7',
      value : '7'
    },{
      key : '8',
      value : '8'
    },{
      key : '9',
      value : '9'
    },{
      key : '10',
      value : '10'
    },{
      key : '11',
      value : '11'
    },{
      key : '12',
      value : '12'
    },{
      key : 'Other',
      value : 'Other'
    }];
    return arr;
  }

  public getGraduationYears(){
    let nextYears = [];
    let currYear = moment().year();
    for (let i = currYear; i < currYear + 18; i++) {
        nextYears.push(i);
    }
    return nextYears;
  } 
  
  private getToken() {
    let user = this.storage.getObject('user');
    return user["api_token"];
  }
  public getAccessToken() {
    let user = this.storage.getObject('user');
    return user["api_token"];
  }

  private getTeamId() {
    let current_user = this.storage.getObject('user');
    return current_user.my_team[0].id;
  }

  private getFileHeaders() {
    let username : string = 'test';
    let p : string = 'test';
    var headers = new Headers();
    headers.append('Access-Control-Allow-Origin','*');
    headers.append("Authorization", "Basic " + btoa(username + ":" + p));
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    let userAgent =  window.navigator.userAgent;
    headers.append('client-web',userAgent);
    return headers;
  }

  private getCSVHeaders() {
    let username : string = 'test';
    let p : string = 'test';
    var headers = new Headers();
    headers.append('Access-Control-Allow-Origin','*');
    headers.append("Authorization", "Basic " + btoa(username + ":" + p));
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/xls');
    let userAgent =  window.navigator.userAgent;
    headers.append('client-web',userAgent);
    return headers;
  }

  private createToken() {
    let username : string = 'test';
    let p : string = 'test';
    let token = btoa(username + ":" + p);
    return token;
  }

  private getHeaders() {
    let username : string = 'dev';
    let p : string = 'dev';
    var headers = new Headers();
    headers.append('Access-Control-Allow-Origin','*');
    headers.append("Authorization", "Basic " + btoa(username + ":" + p));
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    let userAgent =  window.navigator.userAgent;
    headers.append('client-web',userAgent);
    return headers;
  }

  getLeaders() {
    return this.http.get(`${this.baseUrl}users/get-users-by-role/2?api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getNonAssignLeaders() {
    return this.http.get(`${this.baseUrl}users/get-users-by-role/2?api_token=${this.getToken()}&without_team=true`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }

  login(email: string, password: string) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('email', email);
    params.set('password', password);
    return this.http.post(`${this.baseUrl}login`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  forgotPassword(email: string) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('email', email);
    return this.http.post(`${this.baseUrl}password/email`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  getSettings() {
    return this.http.get(`${this.baseUrl}settings/all?api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getLoginMessage() {
    return this.http.get(`${this.baseUrl}settings/get-key/LOGIN_MESSAGE`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getSettingKey(key) {
    return this.http.get(`${this.baseUrl}settings/get-key/${key}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  

  updateSettings(settings: Object) {
    let params: URLSearchParams = new URLSearchParams();
    Object.keys(settings).forEach(function(key) {
      params.set(key.toLowerCase(), settings[key]);
    });

    params.set('api_token', this.getToken());

    return this.http.put(`${this.baseUrl}settings/update`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  downloadSettingFile(id) {
    return this.http.get(`${this.baseUrl}settings/download/${id}?api_token=${this.getToken()}`, { headers: this.getHeaders(), responseType: ResponseContentType.Blob })
    .map((response: Response) => response)
    .catch((error:any) => Observable.throw(error.json()));
  }
  downloadFileWaiver(id,student_id) {
    return this.http.get(`${this.baseUrl}students/download-file/${student_id}/${id}?api_token=${this.getToken()}&&waiver_file=true`, { headers: this.getHeaders(), responseType: ResponseContentType.Blob })
    .map((response: Response) => response)
    .catch((error:any) => Observable.throw(error.json()));
  }
  downloadFile(id,student_id) {
    return this.http.get(`${this.baseUrl}students/download-file/${student_id}/${id}?api_token=${this.getToken()}`, { headers: this.getHeaders(), responseType: ResponseContentType.Blob })
    .map((response: Response) => response)
    .catch((error:any) => Observable.throw(error.json()));
  }
  downloadFileForView(id,student_id) {
    return this.http.get(`${this.baseUrl}students/download-file/${student_id}/${id}?api_token=${this.getToken()}`, { headers: this.getHeaders(), responseType: ResponseContentType.ArrayBuffer })
    .map((response: Response) => response)
    .catch((error:any) => Observable.throw(error.json()));
  }
  downloadLeaderFileWaiver(id,leader_id) {
    return this.http.get(`${this.baseUrl}users/download-file/${leader_id}/${id}?api_token=${this.getToken()}&&waiver_file=true`, { headers: this.getHeaders(), responseType: ResponseContentType.Blob })
    .map((response: Response) => response)
    .catch((error:any) => Observable.throw(error.json()));
  }
  downloadLeaderFile(id,leader_id) {
    return this.http.get(`${this.baseUrl}users/download-file/${leader_id}/${id}?api_token=${this.getToken()}`, { headers: this.getHeaders(), responseType: ResponseContentType.Blob })
    .map((response: Response) => response)
    .catch((error:any) => Observable.throw(error.json()));
  }
  downloadLeaderFileForView(id,leader_id) {
    return this.http.get(`${this.baseUrl}users/download-file/${leader_id}/${id}?api_token=${this.getToken()}`, { headers: this.getHeaders(), responseType: ResponseContentType.ArrayBuffer })
    .map((response: Response) => response)
    .catch((error:any) => Observable.throw(error.json()));
  }

  deleteFile(id,student_id) {
    return this.http.delete(`${this.baseUrl}students/delete-file/${student_id}/${id}?api_token=${this.getToken()}`, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }
  deleteLeaderFile(id,leader_id) {
    return this.http.delete(`${this.baseUrl}users/delete-file/${leader_id}/${id}?api_token=${this.getToken()}`, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }
  deleteUploadedFile(id) {
    return this.http.delete(`${this.baseUrl}uploads/${id}?api_token=${this.getToken()}`, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  getRoutes() {
    return this.http.get(`${this.baseUrl}roles/routes?api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getTeamDetailBySlug(slug) {
    return this.http.get(`${this.baseUrl}teams/get-details-by-slug/${slug}?api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }

  updateRole(routes, id) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('routes', JSON.stringify(routes));
    params.set('api_token', this.getToken());
    return this.http.put(`${this.baseUrl}roles/update/${id}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  // Users

  updateUser(user: User): Observable<User[]> {
    console.log(user);
    let params: URLSearchParams = new URLSearchParams();
    params.set('first_name', user.first_name);
    params.set('last_name', user.last_name);
    params.set('email', user.email);
    params.set('phone', user.phone);
    params.set('api_token', this.getToken());
    params.set('role_id', user.role_id.toString());
    let av = user.active ? '1' : '0';
    params.set('active', av);
    return this.http.put(`${this.baseUrl}users/update/${user.id}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));


  }

  updateProfile(user: User): Observable<User[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('first_name', user.first_name);
    params.set('last_name', user.last_name);
    params.set('email', user.email);
    params.set('phone', user.phone);
    params.set('api_token', this.getToken());
    return this.http.post(`${this.baseUrl}update-profile`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  sendToUser(email:string, role:number, active:boolean) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('email', email);
    params.set('role_id', role.toString());
    let activeStatus = active ? '1' : '0';
    params.set('active', activeStatus.toString());
    
    return this.http.post(`${this.baseUrl}users/store?api_token=${this.getToken()}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }
  sendToBatchUser(email:Array<any>, role:number, active:boolean, team_id:number) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token', this.getToken());
    params.set('emails', JSON.stringify(email));
    params.set('role_id', role.toString());
    let activeStatus = active ? '1' : '0';
    params.set('active', activeStatus.toString());
    if(team_id) {
      params.set('team_id', team_id.toString());
    }
    
    return this.http.post(`${this.baseUrl}users/store-batch`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  sendToUsers(subject, body, group, team_id) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('subject', subject);
    params.set('body', body);
    params.set('group', group);
    if(team_id) {
      params.set('team_id', team_id);
    }
    
    return this.http.post(`${this.baseUrl}email-group?api_token=${this.getToken()}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }
  sendEmailSmsToUsers(group, via, teams, subject, body, event_id, web) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token', this.getToken());
    params.set('group', group);
    params.set('via', via);
    params.set('teams', teams);
    params.set('subject', subject);
    params.set('body', body);
    if(event_id){
      params.set('event_id', event_id);
    }
    if(web != "") {
     params.set(web, '1'); 
    }
    
    return this.http.post(`${this.baseUrl}notify-group`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }
  notifyStudentRun(subject, body, user_id) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token', this.getToken());
    params.set('subject', subject);
    params.set('body', body);
    
    return this.http.post(`${this.baseUrl}notify-student-run/${user_id}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  sendEmergencySMS(body) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('body', body);

    // TODO: THIS WILL CHANGE WHEN API IS ADDED
    return this.http.post(`${this.baseUrl}?api_token=${this.getToken()}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  sendToSMSUsers(body, group, team_id) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('body', body);
    params.set('group', group);
    if(team_id) {
      params.set('team_id', team_id);
    }
    // TODO: THIS WILL CHANGE WHEN API IS ADDED
    return this.http.post(`${this.baseUrl}?api_token=${this.getToken()}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  sendToEventUsers(body, team_id) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('body', body);
    if(team_id) {
      params.set('team_id', team_id);
    }
    // TODO: THIS URL WILL CHANGE WHEN API IS SETUP
    return this.http.post(`${this.baseUrl}?api_token=${this.getToken()}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  deleteUser(id) {
    return this.http.delete(`${this.baseUrl}users/delete/${id}?api_token=${this.getToken()}`, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  setUser(email, phone, first_name, last_name, activation_code, role_id, password, confirm_password) {
    console.log(password+ ' '+ confirm_password);
    let params: URLSearchParams = new URLSearchParams();
    params.set('first_name', first_name);
    params.set('last_name', last_name);
    params.set('email', email);
    params.set('phone', phone);
    params.set('role_id', role_id);
    params.set('password', password);
    params.set('password_confirmation', confirm_password);
    return this.http.post(`${this.baseUrl}activate-account/${activation_code}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }
  registerFamilyUser(email, phone, first_name, last_name, role_id, password, confirm_password, slug) {
    console.log(password+ ' '+ confirm_password);
    let params: URLSearchParams = new URLSearchParams();
    params.set('first_name', first_name);
    params.set('last_name', last_name);
    params.set('email', email);
    params.set('phone', phone);
    params.set('role_id', role_id);
    params.set('password', password);
    params.set('password_confirmation', confirm_password);
    params.set('slug', slug);
    
    return this.http.post(`${this.baseUrl}register-family-by-team-slug`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }
  registerLeaderUser(email, phone, first_name, last_name, role_id, password, confirm_password, slug) {
    console.log(password+ ' '+ confirm_password);
    let params: URLSearchParams = new URLSearchParams();
    params.set('first_name', first_name);
    params.set('last_name', last_name);
    params.set('email', email);
    params.set('phone', phone);
    params.set('role_id', role_id);
    params.set('password', password);
    params.set('password_confirmation', confirm_password);
    params.set('leader_slug', slug);
    
    return this.http.post(`${this.baseUrl}register-leader-by-team-slug`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  getAllUsers() {
    return this.http.get(`${this.baseUrl}users/all?api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }

  searchUser(filter,query,status,page) {
    return this.http.get(`${this.baseUrl}users/all?api_token=${this.getToken()}&query=${query}&role=${filter}&active_status=${status}&page=${page}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getAllFamilyUsers(){
     return this.http.get(`${this.baseUrl}users/all?api_token=${this.getToken()}&page=all&role=Participant Family`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getPagedFamily(page) {
    return this.http.get(`${this.baseUrl}users/all?page=${page}&role=Participant Family&api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  searchFamilyUsers(query,page) {
    return this.http.get(`${this.baseUrl}users/all?api_token=${this.getToken()}&query=${query}&active_status=all&role=Participant Family&page=${page}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getPaged(page) {
    return this.http.get(`${this.baseUrl}users/all?page=${page}&api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }

  getUser(id) {
    return this.http.get(`${this.baseUrl}users/get-details/${id}?api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getLeaderUser() {
    return this.http.get(`${this.baseUrl}users/get-leaders?api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }

  searchLeaderUser(filter,query,status) {
    return this.http.get(`${this.baseUrl}users/get-leaders?api_token=${this.getToken()}&query=${query}&role=Leader&active_status=${status}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  searchTeamLeaderUsers(team_id,query,status) {
    return this.http.get(`${this.baseUrl}users/get-leaders?api_token=${this.getToken()}&page=all&team_id=${team_id}&query=${query}&active_status=${status}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }

  searchLeaderUserPaged(page) {
    return this.http.get(`${this.baseUrl}users/get-leaders?page=${page}&api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  searchLeaderPaged(page,query,status) {
    return this.http.get(`${this.baseUrl}users/get-leaders?page=${page}&api_token=${this.getToken()}&query=${query}&active_status=${status}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  searchWaiver(query) {
    return this.http.get(`${this.baseUrl}waivers/all?api_token=${this.getToken()}&query=${query}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  

  getProfile() {
    return this.http.get(`${this.baseUrl}profile?api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }

  getRoles() {
    return this.http.get(`${this.baseUrl}roles/all?api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }

  getTempUser(token) {
    return this.http.get(`${this.baseUrl}get-user-for-activation/${token}`, { headers: this.getHeaders() })
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  loginAsLeader(user_id) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token',this.getToken());
    return this.http.post(`${this.baseUrl}users/${user_id}/impersonate`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }
  
  attachUser(user_id, student_id) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token',this.getToken());
    params.set('_method', "PUT");
    params.set('user_id', user_id);
    params.set('student_id',student_id);

    return this.http.post(`${this.baseUrl}users/attach-student`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  private extractContent(res: Response) {
    console.log(res);
    let blob = new Blob([(<any> res)._body], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-16le' });
    console.log(blob);
  }

  exportUsers() {
    return this.http.get(`${this.baseUrl}users/export-to-excel?api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  exportActiveUsers() {
    return this.http.get(`${this.baseUrl}users/export-to-excel?active_status=1&api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  exportInactiveUsers() {
    return this.http.get(`${this.baseUrl}users/export-to-excel?active_status=0&api_token=${this.getToken()}`, { headers: this.getHeaders()})
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }

  exportAllLeaders() {
    return this.http.get(`${this.baseUrl}users/export-to-excel?api_token=${this.getToken()}&role=2`, { headers: this.getHeaders() })
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  exportActiveLeaders() {
    return this.http.get(`${this.baseUrl}users/export-to-excel?active_status=1&role=2&api_token=${this.getToken()}`, { headers: this.getHeaders()})
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  exportInactiveLeaders() {
    return this.http.get(`${this.baseUrl}users/export-to-excel?active_status=0&role=2&api_token=${this.getToken()}`, { headers: this.getHeaders()})
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  exportAllLeadersMiles() {
    return this.http.get(`${this.baseUrl}leaders/export-miles-to-excel?active_status=all&api_token=${this.getToken()}&role=2`, { headers: this.getCSVHeaders(), responseType: ResponseContentType.Blob })
    .map((response: Response) => response)
    .catch((error:any) => Observable.throw(error.json()));
  }
  
  // Students
  exportStudents() {
    return this.http.get(`${this.baseUrl}students/export-to-excel?api_token=${this.getToken()}&graduated=1&active=all`, { headers: this.getHeaders() })
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  exportActiveStudents() {
    return this.http.get(`${this.baseUrl}students/export-to-excel?active=1&api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  exportInactiveStudents() {
    return this.http.get(`${this.baseUrl}students/export-to-excel?active=0&graduated=1&api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  exportAllMilesRun() {
    return this.http.get(`${this.baseUrl}students/export-miles-to-excel?api_token=${this.getToken()}`, { headers: this.getCSVHeaders(), responseType: ResponseContentType.Blob })
    .map((response: Response) => response)
    .catch((error:any) => Observable.throw(error.json()));
  }

  getAllSeasonByStudentId(id){
     return this.http.get(`${this.baseUrl}students/student-seasons/${id}?api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getStudentMilesPerEvent(id){
     return this.http.get(`${this.baseUrl}students/miles/per-event?user_id=${id}&api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  


  exportStudentSeasonMiles(seasonObj) {
    return this.http.get(`${this.baseUrl}students/export-student-miles/${seasonObj.student_id}?api_token=${this.getToken()}&range=${seasonObj.range}&start_date=${seasonObj.start_date}&end_date=${seasonObj.end_date}&season_id=${seasonObj.season_id}`, { headers: this.getCSVHeaders(), responseType: ResponseContentType.Blob })
    .map((response: Response) => response)
    .catch((error:any) => Observable.throw(error.json()));
  }

  deleteStudent(id) {
    return this.http.delete(`${this.baseUrl}students/delete/${id}?api_token=${this.getToken()}`, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  addStudentToTeam(student: Student): Observable<Student[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('first_name', student.first_name);
    params.set('last_name', student.last_name);
    params.set('email', student.email);
    params.set('phone', student.phone);
    params.set('date_of_birth', student.date_of_birth);
    params.set('user_id', student.user_id.toString());
    params.set('api_token', this.getToken());
    params.set('team_id', this.getTeamId());

    return this.http.put(`${this.baseUrl}students/update/${student.id}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));


  }

  updateStudent(student: Student): Observable<Student[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('first_name', student.first_name);
    params.set('last_name', student.last_name);
    params.set('phone', student.phone);
    params.set('date_of_birth', student.date_of_birth);
    params.set('user_id', student.user_id.toString());
    params.set('api_token', this.getToken());
    params.set('email', student.email);
    let av = student.available ? '1' : '0';
    params.set('available', av);
    let active = student.active ? '1' : '0';
    params.set('active', active);
    let waiting_list = student.on_waiting_list ? '1' : '0';
    params.set('on_waiting_list', waiting_list);

    params.set('gender', student.gender);
    params.set('home_address', student.home_address);
    params.set('city', student.city);
    params.set('state', student.state);
    let zipData = student.zip ? student.zip.toString() : "";
    params.set('zip', zipData);
    params.set('home_phone', student.home_phone);
    params.set('grade', student.grade);
    params.set('shoe_size', student.shoe_size);
    params.set('shirt_size', student.shirt_size);
    params.set('jacket_size', student.jacket_size);
    params.set('shoe_gender', student.shoe_gender);
    params.set('ethnicity', student.ethnicity);
    params.set('race', student.race);
    params.set('school', student.school);
    params.set('school_id', student.school_id);
    params.set('num_years_in_srp', student.num_years_in_srp);
    params.set('num_marathons_finishes', student.num_marathons_finishes);
    params.set('num_marathons_half_finishes', student.num_marathons_half_finishes);
    params.set('parent_name', student.parent_name);
    params.set('parent_home_phone', student.parent_home_phone);
    params.set('parent_cell_phone', student.parent_cell_phone);
    params.set('parent_email', student.parent_email);
    let pav = student.parent_assist_availability;
    params.set('parent_assist_availability', pav.toString());
    params.set('emergency_name', student.emergency_name);
    params.set('emergency_home_phone', student.emergency_home_phone);
    params.set('emergency_cell_phone', student.emergency_cell_phone);
    params.set('emergency_relationship', student.emergency_relationship);
    params.set('special_code', student.special_code);
    params.set('preferred_method', student.preferred_method);
    params.set('sex', student.sex);
    params.set('enrolled', '1');
    params.set('lgbtq', student.lgbtq);
    params.set('high_school_graduation_year', student.high_school_graduation_year);
    return this.http.put(`${this.baseUrl}students/update/${student.id}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));


  }
updateStudentLater(student: Student): Observable<Student[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('first_name', student.first_name);
    params.set('last_name', student.last_name);
    params.set('phone', student.phone);
    params.set('date_of_birth', student.date_of_birth);
    params.set('user_id', student.user_id.toString());
    params.set('api_token', this.getToken());
    params.set('email', student.email);
    let av = student.available ? '1' : '0';
    params.set('available', av);
    let active = student.active ? '1' : '0';
    params.set('active', active);
    let waiting_list = student.on_waiting_list ? '1' : '0';
    params.set('on_waiting_list', waiting_list);

    params.set('gender', student.gender);
    params.set('home_address', student.home_address);
    params.set('city', student.city);
    params.set('state', student.state);
    let zipData = student.zip ? student.zip.toString() : "";
    params.set('zip', zipData);
    params.set('home_phone', student.home_phone);
    params.set('grade', student.grade);
    params.set('shoe_size', student.shoe_size);
    params.set('shirt_size', student.shirt_size);
    params.set('jacket_size', student.jacket_size);
    params.set('shoe_gender', student.shoe_gender);
    params.set('ethnicity', student.ethnicity);
    params.set('race', student.race);
    params.set('school', student.school);
    params.set('school_id', student.school_id);
    params.set('num_years_in_srp', student.num_years_in_srp);
    params.set('num_marathons_finishes', student.num_marathons_finishes);
    params.set('num_marathons_half_finishes', student.num_marathons_half_finishes);
    params.set('parent_name', student.parent_name);
    params.set('parent_home_phone', student.parent_home_phone);
    params.set('parent_cell_phone', student.parent_cell_phone);
    params.set('parent_email', student.parent_email);
    let pav = student.parent_assist_availability;
    params.set('parent_assist_availability', pav.toString());
    params.set('emergency_name', student.emergency_name);
    params.set('emergency_home_phone', student.emergency_home_phone);
    params.set('emergency_cell_phone', student.emergency_cell_phone);
    params.set('emergency_relationship', student.emergency_relationship);
    params.set('special_code', student.special_code);
    params.set('preferred_method', student.preferred_method);
    params.set('sex', student.sex);
    params.set('lgbtq', student.lgbtq);
    params.set('high_school_graduation_year', student.high_school_graduation_year);
    if(student.team_id) {
      params.set('team_id', student.team_id.toString());
    }
    

    return this.http.put(`${this.baseUrl}students/update-for-later/${student.id}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));


  }
updateStudentLeader(student: Student): Observable<Student[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('first_name', student.first_name);
    params.set('last_name', student.last_name);
    params.set('phone', student.phone);
    params.set('date_of_birth', student.date_of_birth);
    params.set('user_id', student.user_id.toString());
    params.set('api_token', this.getToken());
    params.set('email', student.email);
    let av = student.available ? '1' : '0';
    params.set('available', av);
    let active = student.active ? '1' : '0';
    params.set('active', active);
    let waiting_list = student.on_waiting_list ? '1' : '0';
    params.set('on_waiting_list', waiting_list);

    params.set('gender', student.gender);
    params.set('home_address', student.home_address);
    params.set('city', student.city);
    params.set('state', student.state);
    let zipData = student.zip ? student.zip.toString() : "";
    params.set('zip', zipData);
    params.set('home_phone', student.home_phone);
    params.set('grade', student.grade);
    params.set('shoe_size', student.shoe_size);
    params.set('shirt_size', student.shirt_size);
    params.set('jacket_size', student.jacket_size);
    params.set('shoe_gender', student.shoe_gender);
    params.set('ethnicity', student.ethnicity);
    params.set('race', student.race);
    params.set('school', student.school);
    params.set('school_id', student.school_id);
    params.set('num_years_in_srp', student.num_years_in_srp);
    params.set('num_marathons_finishes', student.num_marathons_finishes);
    params.set('num_marathons_half_finishes', student.num_marathons_half_finishes);
    params.set('parent_name', student.parent_name);
    params.set('parent_home_phone', student.parent_home_phone);
    params.set('parent_cell_phone', student.parent_cell_phone);
    params.set('parent_email', student.parent_email);
    let pav = student.parent_assist_availability;
    params.set('parent_assist_availability', pav.toString());
    params.set('emergency_name', student.emergency_name);
    params.set('emergency_home_phone', student.emergency_home_phone);
    params.set('emergency_cell_phone', student.emergency_cell_phone);
    params.set('emergency_relationship', student.emergency_relationship);
    
    params.set('special_code', student.special_code);
    if(student.team_id) {
      params.set('team_id', student.team_id.toString());
    }
    params.set('preferred_method', student.preferred_method);
    params.set('sex', student.sex);
    params.set('enrolled', '1');
    params.set('lgbtq', student.lgbtq);
    params.set('high_school_graduation_year', student.high_school_graduation_year);
    return this.http.put(`${this.baseUrl}students/update/${student.id}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));


  }
  addStudent(student: Student): Observable<Student[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('first_name', student.first_name);
    params.set('last_name', student.last_name);
    params.set('phone', student.phone);
    params.set('date_of_birth', student.date_of_birth);
    params.set('user_id', student.user_id.toString());
    params.set('api_token', this.getToken());
    params.set('email', student.email);
    if(student.team_id && student.team_id != -1) {
      params.set('team_id', student.team_id.toString());
    }

    let av = student.available ? '1' : '0';
    params.set('available', av);
    let active = student.active ? '1' : '0';
    params.set('active', active);
    let waiting_list = student.on_waiting_list ? '1' : '0';
    params.set('on_waiting_list', waiting_list);
    let waiver = student.waiver_signed ? '1' : '0';
    params.set('waiver_signed', waiver);

    params.set('gender', student.gender);
    params.set('home_address', student.home_address);
    params.set('city', student.city);
    params.set('state', student.state);
    params.set('zip', student.zip.toString());
    params.set('home_phone', student.home_phone);
    params.set('grade', student.grade);
    params.set('shoe_size', student.shoe_size);
    params.set('shirt_size', student.shirt_size);
    params.set('jacket_size', student.jacket_size);
    params.set('shoe_gender', student.shoe_gender);
    params.set('ethnicity', student.ethnicity);
    params.set('race', student.race);
    params.set('school', student.school);
    params.set('school_id', student.school_id);
    params.set('num_years_in_srp', student.num_years_in_srp);
    params.set('num_marathons_finishes', student.num_marathons_finishes);
    params.set('num_marathons_half_finishes', student.num_marathons_half_finishes);
    params.set('parent_name', student.parent_name);
    params.set('parent_home_phone', student.parent_home_phone);
    params.set('parent_cell_phone', student.parent_cell_phone);
    params.set('parent_email', student.parent_email);
    let pav = student.parent_assist_availability;
    params.set('parent_assist_availability', pav.toString());
    params.set('emergency_name', student.emergency_name);
    params.set('emergency_home_phone', student.emergency_home_phone);
    params.set('emergency_cell_phone', student.emergency_cell_phone);
    params.set('emergency_relationship', student.emergency_relationship);
    params.set('special_code', student.special_code);
    params.set('preferred_method', student.preferred_method);
    params.set('sex', student.sex);
    params.set('lgbtq', student.lgbtq);
    params.set('high_school_graduation_year', student.high_school_graduation_year);
    return this.http.post(`${this.baseUrl}students/store`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  addStudentSaveForLater(student: Student): Observable<Student[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('first_name', student.first_name);
    params.set('last_name', student.last_name);
    params.set('phone', student.phone);
    params.set('date_of_birth', student.date_of_birth);
    params.set('user_id', student.user_id.toString());
    params.set('api_token', this.getToken());
    params.set('email', student.email);
    if(student.team_id && student.team_id != -1) {
      params.set('team_id', student.team_id.toString());
    }

    let av = student.available ? '1' : '0';
    params.set('available', av);
    let active = student.active ? '1' : '0';
    params.set('active', active);
    let waiting_list = student.on_waiting_list ? '1' : '0';
    params.set('on_waiting_list', waiting_list);
    let waiver = student.waiver_signed ? '1' : '0';
    params.set('waiver_signed', waiver);

    params.set('gender', student.gender);
    params.set('home_address', student.home_address);
    params.set('city', student.city);
    params.set('state', student.state);
    params.set('zip', student.zip? student.zip.toString() : "");
    params.set('home_phone', student.home_phone);
    params.set('grade', student.grade);
    params.set('shoe_size', student.shoe_size);
    params.set('shirt_size', student.shirt_size);
    params.set('jacket_size', student.jacket_size);
    params.set('shoe_gender', student.shoe_gender);
    params.set('ethnicity', student.ethnicity);
    params.set('race', student.race);
    params.set('school', student.school);
    params.set('school_id', student.school_id);
    params.set('num_years_in_srp', student.num_years_in_srp);
    params.set('num_marathons_finishes', student.num_marathons_finishes);
    params.set('num_marathons_half_finishes', student.num_marathons_half_finishes);
    params.set('parent_name', student.parent_name);
    params.set('parent_home_phone', student.parent_home_phone);
    params.set('parent_cell_phone', student.parent_cell_phone);
    params.set('parent_email', student.parent_email);
    let pav = student.parent_assist_availability;
    params.set('parent_assist_availability', pav ? pav.toString() : "");
    params.set('emergency_name', student.emergency_name);
    params.set('emergency_home_phone', student.emergency_home_phone);
    params.set('emergency_cell_phone', student.emergency_cell_phone);
    params.set('emergency_relationship', student.emergency_relationship);
    params.set('special_code', student.special_code);
    params.set('preferred_method', student.preferred_method);
    params.set('sex', student.sex);
    params.set('lgbtq', student.lgbtq);
    params.set('high_school_graduation_year', student.high_school_graduation_year);
    return this.http.post(`${this.baseUrl}students/save-for-later`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  getMyStudents() {
    return this.http.get(`${this.baseUrl}students/my?api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getMyStudentsByPages(page) {
    return this.http.get(`${this.baseUrl}students/my?page=${page}&api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }

  getStudent(id) {
    return this.http.get(`${this.baseUrl}students/get-details/${id}?api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }

  getStudents() {
    return this.http.get(`${this.baseUrl}students/all?api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getAllStudents() {
    return this.http.get(`${this.baseUrl}students/all?api_token=${this.getToken()}&page=all`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }

  searchStudents(search) {
    return this.http.get(`${this.baseUrl}students/all?api_token=${this.getToken()}&query=${search}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }

  searchStudentsLeader(search) {
    console.log(`${this.baseUrl}students/all?api_token=${this.getToken()}&query=${search}&team=null`);
    return this.http.get(`${this.baseUrl}students/all?api_token=${this.getToken()}&query=${search}&team=null`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  searchStudentsTeam(search,team_id) {
    return this.http.get(`${this.baseUrl}students/all?api_token=${this.getToken()}&query=${search}&team=${team_id}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }

  getLeaderStudents() {
    return this.http.get(`${this.baseUrl}students/all?api_token=${this.getToken()}&team=null`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }

  getLeaderStudentsByID(team_id) {
    return this.http.get(`${this.baseUrl}students/all?api_token=${this.getToken()}&team=${team_id}&page=all`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getTeamStudentsByIDStatus(team_id,search,status) {
    return this.http.get(`${this.baseUrl}students/all?api_token=${this.getToken()}&team=${team_id}&query=${search}&active=${status}&page=all`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getLeaderNonGraduatedStudentsByID(team_id) {
    //&graduated=0
    return this.http.get(`${this.baseUrl}students/all?api_token=${this.getToken()}&team=${team_id}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getLeaderAllStudentsByID(team_id) {
    return this.http.get(`${this.baseUrl}students/all?api_token=${this.getToken()}&team=${team_id}&page=all`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getAllStudentsByFamilyID(family_id) {
    return this.http.get(`${this.baseUrl}students/all?api_token=${this.getToken()}&user_id=${family_id}&page=all`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }

  searchStudentsByName(term: string): Observable<StudentItem[]> {
    return this.http.get(`${this.baseUrl}students/all?api_token=${this.getToken()}&query=${term}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => {
        response = response.json();
        let dataStud = response['data'].students;
        return dataStud.data.map(item => {
          return new StudentItem(
            item.first_name,
            item.last_name,
            item.user_id,
            item.id,
            item.team,
            item.email,
            item.first_last_name = item.first_name + " " + item.last_name,
            item.miles_run = item.miles  
          );
        });
      })
    .catch((error:any) => Observable.throw(error.json()));
  }
  searchFamilyUserByName(term: string): Observable<FamilyItem[]> {
    return this.http.get(`${this.baseUrl}users/all?api_token=${this.getToken()}&query=${term}&role=Participant Family`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => {
        response = response.json();
        let dataFamily = response['data'].users;
        return dataFamily.data.map(item => {
          return new FamilyItem(
            item.first_name,
            item.last_name,
            item.id,
            item.team_name,
            item.email,
            item.first_last_name = item.first_name + " " + item.last_name
          );
        });
      })
    .catch((error:any) => Observable.throw(error.json()));
  }

  searchStudentsTeamUsingStatus(search,team_id,status) {
    return this.http.get(`${this.baseUrl}students/all?api_token=${this.getToken()}&query=${search}&team=${team_id}&active_status=${status}&page=all`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  searchStudentsFamilyUsingStatus(search,family_id,status) {
    return this.http.get(`${this.baseUrl}students/all?api_token=${this.getToken()}&query=${search}&user_id=${family_id}&active_status=${status}&page=all`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  searchLeaderStudentsByStatus(search) {
    return this.http.get(`${this.baseUrl}students/all?api_token=${this.getToken()}&query=${search}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }

  getLeaderStudentsByIDVerified(team_id) {
    return this.http.get(`${this.baseUrl}students/all?api_token=${this.getToken()}&team=${team_id}&enrollment_status=green&active=1`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getPagedStudentByTeam(page,team_id) {
    return this.http.get(`${this.baseUrl}students/all?page=${page}&api_token=${this.getToken()}&team=${team_id}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }

  getPagedStudent(page) {
    return this.http.get(`${this.baseUrl}students/all?page=${page}&api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getPagedStudentFilter(page,query) {
    return this.http.get(`${this.baseUrl}students/all?page=${page}&api_token=${this.getToken()}&query=${query}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }

  setStudent(student: Student) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token',this.getToken());
    params.set('first_name', student.first_name);
    params.set('last_name', student.last_name);
    params.set('phone', student.phone);
    params.set('email', student.email);
    params.set('date_of_birth', student.date_of_birth);
    params.set('user_id', student.user_id.toString());
    if(student.team_id) {
      params.set('team_id', student.team_id.toString());
    }
    return this.http.post(`${this.baseUrl}students/store`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  graduateStudent(graduation) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token',this.getToken());
    params.set('_method', "PUT");
    params.set('graduation_status', graduation.title);
    params.set('graduation_reason', graduation.reason);
    if(graduation.sendemail){
      let activeBool = graduation.sendemail ? 1 : 0;
      params.set('sendemail',  activeBool.toString());
    }

    return this.http.post(`${this.baseUrl}students/update-graduation-status/${graduation.id}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }
  addStudentComment(comment, id) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token',this.getToken());
    params.set('body', comment);

    return this.http.post(`${this.baseUrl}students/comments/store/${id}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  addFile(file, id) {
    return Observable.create(observer => {
      let formData: FormData = new FormData(),
        xhr: XMLHttpRequest = new XMLHttpRequest();

        formData.append('file', file);
        formData.append('title', file.name);
        formData.append('api_token', this.getToken());
        formData.append('type', file.type);
        formData.append('notes','');

      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            observer.next(JSON.parse(xhr.response));
            observer.complete();
          } else {
            observer.error(JSON.parse(xhr.response));
          }
        }
      };

      xhr.upload.onprogress = (event) => {
        this.progress = Math.round(event.loaded / event.total * 100);
        this.progressObserver.next(this.progress);
      };

      xhr.open('POST', `${this.baseUrl}students/upload-file/${id}`, true);
      xhr.setRequestHeader('Authorization', 'Basic ' + this.createToken());
      xhr.send(formData);
    });
  }
  uploadWaiverFiles(waiverObj, waiverFilesArray) {
    return Observable.create(observer => {
      let formData: FormData = new FormData(),
        xhr: XMLHttpRequest = new XMLHttpRequest();
        
        let filesArray = new Array();
        for (var i in waiverFilesArray) {
            let waiverObj = waiverFilesArray[i];
            filesArray.push(waiverObj.file);
            formData.append('names['+i+']', waiverObj.name);
            formData.append('files[]', waiverObj.file);
        }
        formData.append('api_token', this.getToken());
        

      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            try{
              observer.next(JSON.parse(xhr.response));
            }catch(e){

            }finally{
              observer.complete();  
            }
          } else {
            observer.error(JSON.parse(xhr.response));
          }
        }
      };

      xhr.upload.onprogress = (event) => {
        this.progress = Math.round(event.loaded / event.total * 100);
        try{
          this.progressObserver.next(this.progress);
        }catch(e){

        }finally{

        }
      };

      xhr.open('POST', `${this.baseUrl}waivers/upload-files/${waiverObj.id}`, true);
      xhr.setRequestHeader('Authorization', 'Basic ' + this.createToken());
      xhr.send(formData);
    });
  }
  //Approve/Deny File
  updateFileStatus(fileObj) {
    console.log(fileObj);
    let params: URLSearchParams = new URLSearchParams();
    
    params.set('api_token',this.getToken());
    params.set('_method', "PUT");
    params.set('status', fileObj.status.toString());
    params.set('status_msg', fileObj.status_msg);

    return this.http.put(`${this.baseUrl}uploads/update-status/${fileObj.id}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  // Teams
  getAllTeams() {
    return this.http.get(`${this.baseUrl}teams/all?api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getAllTeamsList() {
    return this.http.get(`${this.baseUrl}teams/all?api_token=${this.getToken()}&page=all`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }

  searchTeam(search) {
    return this.http.get(`${this.baseUrl}teams/all?api_token=${this.getToken()}&query=${search}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  searchPageTeam(page,search) {
    return this.http.get(`${this.baseUrl}teams/all?api_token=${this.getToken()}&page=${page}&query=${search}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }

  getMyTeam() {
    return this.http.get(`${this.baseUrl}teams/get-details/${this.getTeamId()}?api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }

  getAdminTeam(id) {
    return this.http.get(`${this.baseUrl}teams/get-details/${id}?api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }

  getMyTeamForEvent(event_id, id) {
    return this.http.get(`${this.baseUrl}events/get-my-students/${event_id}/${id}?api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }

  getPagedTeam(page) {
    return this.http.get(`${this.baseUrl}teams/all?page=${page}&api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }

  addTeam(team: Team) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token',this.getToken());
    params.set('name', team.name);
    let activeBool = team.active ? '1' : '0';
    params.set('active', activeBool);
    let leader = team.owner ? JSON.stringify(team.owner) : '';
    params.set('owner', leader);

    params.set('affiliate_school', team.affiliate_school);
    params.set('school_address', team.school_address);
    let zip = team.school_zip ? team.school_zip.toString() : "";
    params.set('school_zip', zip);
    params.set('established_at', team.established_at);
    params.set('details', team.details);
    params.set('slug', team.slug);
    params.set('training_link', team.training_link);
    params.set('leader_slug', team.leader_slug);

    return this.http.post(`${this.baseUrl}teams/store`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  getTeam(id) {
    return this.http.get(`${this.baseUrl}teams/get-details/${id}?api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getTeamByEnrollmentStatus(id, age, miles, event_id) {
    return this.http.get(`${this.baseUrl}teams/get-team-by-enrollment-status/${id}?api_token=${this.getToken()}&enrollment_status=green&age=${age}&miles=${miles}&event_id=${event_id}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }

  updateTeam(team: Team) {
    console.log(team);
    let params: URLSearchParams = new URLSearchParams();
    params.set('name', team.name);
    let activeBool = team.active ? 1 : 0;
    params.set('active', activeBool.toString());
    params.set('api_token',this.getToken());
    params.set('owner', JSON.stringify(team.owner));
    
    params.set('affiliate_school', team.affiliate_school);
    params.set('school_address', team.school_address);
    let zip = team.school_zip ? team.school_zip.toString() : "";
    params.set('school_zip', zip);
    params.set('established_at', team.established_at);
    params.set('details', team.details);
    params.set('slug', team.slug);
    params.set('password', team.password);
    params.set('password_confirmation', team.password_confirmation);
    params.set('leader_slug', team.leader_slug);
    params.set('training_link', team.training_link);
    return this.http.put(`${this.baseUrl}teams/update/${team.id}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  deleteTeam(id) {
    return this.http.delete(`${this.baseUrl}teams/delete/${id}?api_token=${this.getToken()}`, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  // Events
  getAllEvents() {
    return this.http.get(`${this.baseUrl}events/all?api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getAllEventsByTeamID(team_id) {
    return this.http.get(`${this.baseUrl}events/all?api_token=${this.getToken()}&team_id=${team_id}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getAllEventsByTeam(id) {
    return this.http.get(`${this.baseUrl}events/get-events-by-team/${id}?api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }

  getPagedEvent(page) {
    return this.http.get(`${this.baseUrl}events/all?page=${page}&api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }

  deleteEvent(id) {
    return this.http.delete(`${this.baseUrl}events/delete/${id}?api_token=${this.getToken()}`, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  searchEvent(value) {
    return this.http.get(`${this.baseUrl}events/all?api_token=${this.getToken()}&query=${value}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }

  addEvent(event: Event) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token',this.getToken());
    params.set('name', event.name);
    params.set('location', event.location);
    params.set('start_date', event.start_date);
    params.set('deadline', event.deadline);
    let activeBool = event.transportation_available ? 1 : 0;
    params.set('transportation_available', activeBool.toString());
    params.set('notes', event.notes);
    params.set('held_date', event.held_date);
    params.set('eligible_teams', JSON.stringify(event.eligible_teams));
    let volunteerBool = event.volunteers ? 1 : 0;
    params.set('volunteers', volunteerBool.toString());
    
    params.set('age', event.age ? event.age.toString() : "0");
    let ageBool = event.age_flag ? 1 : 0;
    params.set('age_flag', ageBool.toString());

    params.set('miles', event.miles ? event.miles.toString() : "0");
    let milesBool = event.miles_flag ? 1 : 0;
    params.set('miles_flag', milesBool.toString());

    console.log(params);
    return this.http.post(`${this.baseUrl}events/store`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  getEvent(id) {
    return this.http.get(`${this.baseUrl}events/get-details/${id}?api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }

  updateEvent(event: Event) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('name', event.name);
    params.set('start_date', event.start_date);
    params.set('deadline', event.deadline);
    params.set('api_token',this.getToken());
    params.set('location', event.location);
    let activeBool = event.transportation_available ? 1 : 0;
    params.set('transportation_available', activeBool.toString());
    params.set('notes', event.notes);
    params.set('held_date', event.held_date);
    params.set('eligible_teams', JSON.stringify(event.eligible_teams));
    let volunteerBool = event.volunteers ? 1 : 0;
    params.set('volunteers', volunteerBool.toString());

    params.set('age', event.age ? event.age.toString() : "0");
    let ageBool = event.age_flag ? 1 : 0;
    params.set('age_flag', ageBool.toString());

    params.set('miles', event.miles ? event.miles.toString() : "0");
    let milesBool = event.miles_flag ? 1 : 0;
    params.set('miles_flag', milesBool.toString());
    
    return this.http.put(`${this.baseUrl}events/update/${event.id}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  saveStudentInfo(id, miles, notes, event_id, completed) {
    console.log(id);
    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token',this.getToken());
    params.set('miles', miles);
    params.set('notes', notes);
    params.set('completed', completed);
    
    return this.http.post(`${this.baseUrl}events/students/update-assignment/${event_id}/${id}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));

    // return this.http.post(`${this.baseUrl}events/students/update/${event_id}`, params, { headers: this.getHeaders() })
    //         .map((response: Response) => response.json())
    //         .catch((error:any) => Observable.throw(error.json()));
  }

  saveTodayMilesStudentInfo(arrStudentIds, miles, date) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token',this.getToken());
    params.set('students', JSON.stringify(arrStudentIds));
    params.set('miles', miles);
    params.set('notes', '');
    params.set('date', date);
    
    return this.http.post(`${this.baseUrl}students/miles/set-today-miles-batch`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }
  saveTodayMilesLeadersInfo(arrLeadersId, miles, date) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token',this.getToken());
    params.set('leaders', JSON.stringify(arrLeadersId));
    params.set('miles', miles);
    params.set('notes', '');
    params.set('date', date);
    
    return this.http.post(`${this.baseUrl}leaders/miles/set-today-miles-batch`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  updateSingleTodayMilesStudentInfo(id, miles, notes, date) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token',this.getToken());
    params.set('miles', miles);
    params.set('notes', notes);
    params.set('date', date);
    
    return this.http.post(`${this.baseUrl}students/miles/set-today-miles/${id}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }
  updateSingleTodayMilesLeaderInfo(id, miles, notes, date) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token',this.getToken());
    params.set('miles', miles);
    params.set('notes', notes);
    params.set('date', date);
    
    return this.http.post(`${this.baseUrl}leaders/miles/set-today-miles/${id}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  updateTransportation(id, event_id, transportation) {
    console.log(id);
    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token',this.getToken());
    params.set('student_id', id);
    params.set('completed', '0');
    params.set('transportation_needed',transportation);

    return this.http.post(`${this.baseUrl}events/students/update/${event_id}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  addStudentToEvent(id, event_id, needs_transportation) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token',this.getToken());
    params.set('student_id', id);
    params.set('completed', '0');
    params.set('transportation_needed',needs_transportation);
    return this.http.post(`${this.baseUrl}events/students/assign/${event_id}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  removeStudentToEvent(id, event_id) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token',this.getToken());
    params.set('student_id', id);

    return this.http.post(`${this.baseUrl}events/students/delete/${event_id}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  exportEvent(id) {
    return this.http.get(`${this.baseUrl}events/export-to-excel/${id}?api_token=${this.getToken()}`, { headers: this.getCSVHeaders(), responseType: ResponseContentType.Blob })
    .map((response: Response) => response)
    .catch((error:any) => Observable.throw(error.json()));
  }

  // Surveys
  getAllSurveys() {
    return this.http.get(`${this.baseUrl}surveys/all?api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }

  searchSurveys(search) {
    return this.http.get(`${this.baseUrl}surveys/all?api_token=${this.getToken()}&query=${search}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }

  getPagedSurvey(page) {
    return this.http.get(`${this.baseUrl}surveys/all?page=${page}&api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }

  deleteSurvey(id) {
    return this.http.delete(`${this.baseUrl}surveys/delete/${id}?api_token=${this.getToken()}`, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  addSurvey(survey: Survey) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token',this.getToken());
    params.set('name', survey.name);
    params.set('status', survey.status);
    params.set('description', survey.description);
    params.set('starts_at', survey.starts_at);
    params.set('ends_at', survey.ends_at);
    params.set('email_subject', survey.email_subject);
    params.set('email_body', survey.email_body);

    return this.http.post(`${this.baseUrl}surveys/store`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  addQuestion(question: Question) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token',this.getToken());
    params.set('title', question.title);
    params.set('type', question.type);
    params.set('survey_id', question.survey_id.toString());
    params.set('order', question.order.toString());
    if(question.options) {
      params.set('options', question.options);
    }

    return this.http.post(`${this.baseUrl}surveys/questions/store`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  getSurvey(id) {
    return this.http.get(`${this.baseUrl}surveys/get-details/${id}?api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }

  updateSurvey(survey: Survey) {
    console.log(survey);
    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token',this.getToken());
    params.set('name', survey.name);
    params.set('status', survey.status);
    params.set('description', survey.description);
    params.set('starts_at', survey.starts_at);
    params.set('ends_at', survey.ends_at);
    params.set('email_subject', survey.email_subject);
    params.set('email_body', survey.email_body);

    return this.http.put(`${this.baseUrl}surveys/update/${survey.id}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  updateQuestion(question: Question, options) {
    console.log(question);
    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token',this.getToken());
    params.set('title', question.title);
    params.set('type', question.type);
    params.set('survey_id', question.survey_id.toString());
    params.set('order', question.order.toString());
    if(options) {
      params.set('options', options);
    }

    return this.http.put(`${this.baseUrl}surveys/questions/update/${question.id}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }
  updateOrder(survey_id, options) {
    
    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token',this.getToken());
    params.set('questions_order', JSON.stringify(options));
    params.set('_method', "PUT");
    

    return this.http.put(`${this.baseUrl}surveys/update-order/${survey_id}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  deleteQuestion(id) {
    return this.http.delete(`${this.baseUrl}surveys/questions/delete/${id}?api_token=${this.getToken()}`, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  completeSurvey(id, questions) {
    console.log(JSON.stringify(questions));
    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token',this.getToken());
    params.set('questions', JSON.stringify(questions));

    return this.http.post(`${this.baseUrl}surveys/submit/${id}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }
  getCategoryOptions(cat){
    return this.http.get(`${this.baseUrl}get-category-options/${cat}?api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
    //
  }

  enrollLeader(leader: Leader,user): Observable<Student[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token', this.getToken());
    params.set('first_name', leader.first_name);
    params.set('last_name', leader.last_name);
    params.set('gender', leader.gender);
    params.set('birth_date', leader.birth_date);
    params.set('shoe_size', leader.shoe_size);
    params.set('shirt_size', leader.shirt_size);
    params.set('jacket_size', leader.jacket_size);
    params.set('ethnicity', leader.ethnicity);
    params.set('race', leader.race);
    params.set('address', leader.address);
    params.set('city', leader.city);
    params.set('state', leader.state);
    params.set('zip', leader.zip ? leader.zip.toString() : "");
    params.set('home_phone', leader.home_phone);
    params.set('cell_phone', leader.cell_phone);
    params.set('email', leader.email);
    params.set('team_name', leader.team_name);
    params.set('employer', leader.employer);
    params.set('occupation', leader.occupation);
    params.set('completed_year_count_sr', leader.completed_year_count_sr);
    params.set('finished_marathon_count_sr', leader.finished_marathon_count_sr);
    params.set('half_marathon_count_sr', leader.half_marathon_count_sr);
    params.set('emergency_contact_first_name', leader.emergency_contact_first_name);
    params.set('emergency_contact_last_name', leader.emergency_contact_last_name);
    params.set('emergency_contact_home_phone', leader.emergency_contact_home_phone);
    params.set('emergency_contact_cell_phone', leader.emergency_contact_cell_phone);
    params.set('emergency_contact_relation', leader.emergency_contact_relation);
    params.set('student_in_program', leader.student_in_program ? leader.student_in_program.toString() : "");
    params.set('languages', leader.languages);
    params.set('shoe_gender', leader.shoe_gender);
    params.set('jr_leader', leader.jr_leader ? leader.jr_leader.toString() : '');
    params.set('special_code', leader.special_code);
    params.set('training', leader.training);
    params.set('preferred_method', leader.preferred_method ? leader.preferred_method.toString() : '');
    params.set('sex', leader.sex);
    params.set('enrolled', "1");
    params.set('lgbtq', leader.lgbtq);
    return this.http.post(`${this.baseUrl}users/${user}/enrollment/store`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }
  enrollLeaderLater(leader: Leader,user): Observable<Student[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token', this.getToken());
    params.set('first_name', leader.first_name);
    params.set('last_name', leader.last_name);
    params.set('gender', leader.gender);
    params.set('birth_date', leader.birth_date);
    params.set('shoe_size', leader.shoe_size);
    params.set('shirt_size', leader.shirt_size);
    params.set('jacket_size', leader.jacket_size);
    params.set('ethnicity', leader.ethnicity);
    params.set('race', leader.race);
    params.set('address', leader.address);
    params.set('city', leader.city);
    params.set('state', leader.state);
    params.set('zip', leader.zip ? leader.zip.toString() : "");
    params.set('home_phone', leader.home_phone);
    params.set('cell_phone', leader.cell_phone);
    params.set('email', leader.email);
    params.set('team_name', leader.team_name);
    params.set('employer', leader.employer);
    params.set('occupation', leader.occupation);
    params.set('completed_year_count_sr', leader.completed_year_count_sr);
    params.set('finished_marathon_count_sr', leader.finished_marathon_count_sr);
    params.set('half_marathon_count_sr', leader.half_marathon_count_sr);
    params.set('emergency_contact_first_name', leader.emergency_contact_first_name);
    params.set('emergency_contact_last_name', leader.emergency_contact_last_name);
    params.set('emergency_contact_home_phone', leader.emergency_contact_home_phone);
    params.set('emergency_contact_cell_phone', leader.emergency_contact_cell_phone);
    params.set('emergency_contact_relation', leader.emergency_contact_relation);
    params.set('student_in_program', leader.student_in_program ? leader.student_in_program.toString() : "");
    params.set('languages', leader.languages);
    params.set('shoe_gender', leader.shoe_gender);
    params.set('jr_leader', leader.jr_leader ? leader.jr_leader.toString() : '');
    params.set('special_code', leader.special_code);
    params.set('preferred_method', leader.preferred_method ? leader.preferred_method.toString() : '');
    params.set('sex', leader.sex);
    params.set('enrolled', "0");
    params.set('training', leader.training);
    params.set('lgbtq', leader.lgbtq);
    return this.http.post(`${this.baseUrl}users/${user}/enrollment/save-for-later`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  assignSurvey(surveyData) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token', this.getToken());
    params.set('model', surveyData.model);
    params.set('category', surveyData.category);
    if(surveyData.model == "App\\Student"){
      params.set('value', surveyData.value);
    }
    
    return this.http.post(`${this.baseUrl}surveys/assignment/${surveyData.id}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  registerMyTeamToEvent(eventData) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token', this.getToken());
    params.set('students', JSON.stringify(eventData.students));
    params.set('leaders', JSON.stringify(eventData.leaders));
    params.set('team_id', eventData.team_id);
    params.set('leader_id', eventData.leader_id);
    params.set('team_num_seats', eventData.team_num_seats);
    params.set('team_num_tokens', eventData.team_num_tokens);
    params.set('leader_first_name', eventData.leader_first_name);
    params.set('leader_last_name', eventData.leader_last_name);
    params.set('leader_contact', eventData.leader_contact);
    params.set('volunteers', eventData.volunteers ? '1' : '0');
    
    return this.http.post(`${this.baseUrl}events/students/batch-assign/${eventData.id}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }
  registerMyTeamToEventParticipate(eventData) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token', this.getToken());
    //params.set('students', JSON.stringify(eventData.students));
    //params.set('leaders', JSON.stringify(eventData.leaders));
    params.set('new_students', JSON.stringify(eventData.new_students));
    params.set('detached_students', JSON.stringify(eventData.detached_students));
    params.set('new_leaders', JSON.stringify(eventData.new_leaders));
    params.set('detached_leaders', JSON.stringify(eventData.detached_leaders));

    params.set('team_id', eventData.team_id);
    params.set('leader_id', eventData.leader_id);
    params.set('team_num_seats', eventData.team_num_seats);
    params.set('team_num_tokens', eventData.team_num_tokens);
    params.set('leader_first_name', eventData.leader_first_name);
    params.set('leader_last_name', eventData.leader_last_name);
    params.set('leader_contact', eventData.leader_contact);
    params.set('volunteers', eventData.volunteers ? '1' : '0');
    
    return this.http.post(`${this.baseUrl}events/students/batch-assign/${eventData.id}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }
  getMyEventRegisteredVolunteers(id) {
    return this.http.get(`${this.baseUrl}events/volunteers/get-by-event/${id}?api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  registerMyVolunteersToEvent(eventData) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token', this.getToken());
    params.set('volunteers', JSON.stringify(eventData.volunteers));
    
    return this.http.post(`${this.baseUrl}events/volunteers/store-update/${eventData.id}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }
  unregisterTeamEvent(event_id, team_id)
 {
    return this.http.delete(`${this.baseUrl}events/unassign-event-team/${event_id}/${team_id}?api_token=${this.getToken()}`, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }
  addWaiver(waiver) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token', this.getToken());
    params.set('name', waiver.name);
    params.set('assign_to', waiver.assign_to);
    if(waiver.assign_to == "Teams"){
      params.set('teams', JSON.stringify(waiver.teams));
    }
    return this.http.post(`${this.baseUrl}waivers/store`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }
  getAllWaivers() {
    return this.http.get(`${this.baseUrl}waivers/all?api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  deleteWaiver(id) {
    return this.http.delete(`${this.baseUrl}waivers/delete/${id}?api_token=${this.getToken()}`, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }
  deleteWaiverFile(id) {
    return this.http.delete(`${this.baseUrl}uploads/${id}?api_token=${this.getToken()}`, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }
  getWaiverPaged(page) {
    return this.http.get(`${this.baseUrl}waivers/all?page=${page}&api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  updateWaiver(waiver) {
    console.log(waiver);
    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token',this.getToken());
    params.set('_method', "PUT");
    params.set('name', waiver.name);
    params.set('assign_to', waiver.assign_to);
    if(waiver.assign_to == "Teams"){
      params.set('teams', JSON.stringify(waiver.teams));
    }

    return this.http.put(`${this.baseUrl}waivers/update/${waiver.id}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }
  getWaiverDetail(id) {
    return this.http.get(`${this.baseUrl}waivers/get-details/${id}?api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getWaiverTeams() {
    return this.http.get(`${this.baseUrl}waivers/get-teams-for-assignment?api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getTeamWaiver(id) {
    return this.http.get(`${this.baseUrl}waivers/get-waivers?api_token=${this.getToken()}&team_id=${id}&type=leaders&assign_to=leader`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getStudentTeamWaiver(id) {
    return this.http.get(`${this.baseUrl}waivers/get-waivers?api_token=${this.getToken()}&team_id=${id}&type=students&assign_to=family`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getAllDocuments() {
    return this.http.get(`${this.baseUrl}uploads/all?api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  
  getPagedDocument(page) {
    return this.http.get(`${this.baseUrl}uploads/all?page=${page}&api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  updateDocumentFileStatus(fileObj) {
    console.log(fileObj);
    let params: URLSearchParams = new URLSearchParams();
    
    params.set('api_token',this.getToken());
    params.set('_method', "PUT");
    params.set('status', fileObj.status.toString());
    params.set('status_msg', fileObj.status_msg);
    params.set('expiration_date', fileObj.expiration_date);  
    return this.http.post(`${this.baseUrl}uploads/update-status/${fileObj.id}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }
  updateDocumentFileStatusMultiple(fileObj) {
    console.log(fileObj);
    let params: URLSearchParams = new URLSearchParams();
    
    params.set('api_token',this.getToken());
    params.set('_method', "PUT");
    params.set('status', fileObj.status.toString());
    params.set('file_ids',  JSON.stringify(fileObj.file_ids));
    params.set('status_msg', fileObj.status_msg);

    return this.http.post(`${this.baseUrl}uploads/update-status-multiple`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  getWaiverSignature(id,userType) {
    return this.http.get(`${this.baseUrl}waivers/get-signatures?id=${id}&type=${userType}&api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  signedWaiverFiles(waiverObj, waiverFilesArray) {
    return Observable.create(observer => {
      let formData: FormData = new FormData(),
        xhr: XMLHttpRequest = new XMLHttpRequest();
        
        let filesArray = new Array();
        for (var i in waiverFilesArray) {
            let waiverObject = waiverFilesArray[i];
            formData.append('files[]', waiverObject);
        }
        //formData.append('files[]', waiverFilesArray);
        formData.append('api_token', this.getToken());
        formData.append('type', 'Waiver Signature');
        formData.append('files_details', JSON.stringify(waiverObj.files_details));
        formData.append('signer_id', waiverObj.signer_id);
        formData.append('signer_type', waiverObj.signer_type);
        

      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            try{
              observer.next(JSON.parse(xhr.response));
            }catch(e){

            }finally{
              observer.complete();  
            }
          } else {
            observer.error(JSON.parse(xhr.response));
          }
        }
      };

      xhr.upload.onprogress = (event) => {
        this.progress = Math.round(event.loaded / event.total * 100);
        try{
          this.progressObserver.next(this.progress);
        }catch(e){

        }finally{

        }
      };

      xhr.open('POST', `${this.baseUrl}waivers/sign-waiver`, true);
      xhr.setRequestHeader('Authorization', 'Basic ' + this.createToken());
      xhr.send(formData);
    });
  }
  checkoutTeamFromEventModified(event_id, dict) {

    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token', this.getToken());
    params.set('students[completed]', JSON.stringify(dict.completed_students));
    params.set('students[notcompleted]', JSON.stringify(dict.notcompleted_students));
    params.set('students[didnotshowup]', JSON.stringify(dict.didnotshowup_students));

    params.set('leaders[completed]', JSON.stringify(dict.completed_leaders));
    params.set('leaders[notcompleted]', JSON.stringify(dict.notcompleted_leaders));
    params.set('leaders[didnotshowup]', JSON.stringify(dict.didnotshowup_leaders));
    params.set('team_id', dict.team_id);
    
    return this.http.post(`${this.baseUrl}events/check-out/${event_id}/true?api_token=${this.getToken()}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }
  checkoutTeamFromEvent(event_id, dict) {

    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token', this.getToken());
    params.set('students', JSON.stringify(dict.students));
    params.set('leaders', JSON.stringify(dict.leaders));
    params.set('team_id', dict.team_id);
    
    return this.http.post(`${this.baseUrl}events/check-out/${event_id}/true?api_token=${this.getToken()}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }
  updateEventAssignmentStudents(event_id,students) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token',this.getToken());
    params.set('students', JSON.stringify(students));

    return this.http.post(`${this.baseUrl}events/students/update-assignment-batch/${event_id}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }

  exportSurveyUsingID(id) {
    return this.http.get(`${this.baseUrl}surveys/export/${id}?api_token=${this.getToken()}`, { headers: this.getCSVHeaders(), responseType: ResponseContentType.Blob })
    .map((response: Response) => response)
    .catch((error:any) => Observable.throw(error.json()));
  }
  exportMyTeam(id) {
    return this.http.get(`${this.baseUrl}students/export-to-excel?api_token=${this.getToken()}&team=${id}`, { headers: this.getCSVHeaders(), responseType: ResponseContentType.Blob })
    .map((response: Response) => response)
    .catch((error:any) => Observable.throw(error.json()));
  }
  getMilesTodayByDates(start_date, end_date, team_id,status) {
    return this.http.get(`${this.baseUrl}students/miles?api_token=${this.getToken()}&start_date=${start_date}&end_date=${end_date}&team=${team_id}&page=all&active_status=${status}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getFamilyMilesTodayByDates(start_date, end_date, user_id,status) {
    return this.http.get(`${this.baseUrl}students/miles?api_token=${this.getToken()}&start_date=${start_date}&end_date=${end_date}&user_id=${user_id}&page=all&active_status=${status}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getMilesTodayByDatesLeaders(start_date, end_date, team_id,status) {
    return this.http.get(`${this.baseUrl}leaders/miles?api_token=${this.getToken()}&start_date=${start_date}&end_date=${end_date}&team=${team_id}&page=all&active_status=${status}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }

  getAdminEnrollUsers() {
    return this.http.get(`${this.baseUrl}users/get-my-students-users?api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }  
  getAdminEnrollUsersByPage(query,status,filter_type) {
    return this.http.get(`${this.baseUrl}users/get-my-students-users?api_token=${this.getToken()}&query=${query}&active_status=${status}&filter_type=${filter_type}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  adminCreateLeader(user: User, password) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token', this.getToken());
    params.set('first_name', user.first_name);
    params.set('last_name', user.last_name);
    params.set('email', user.email);
    params.set('phone', user.phone);
    params.set('role_id', user.role_id.toString());
    params.set('active', '1');
    params.set('password', password);
    params.set('password_confirmation', password);
    
    return this.http.post(`${this.baseUrl}users/store?api_token=${this.getToken()}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }
  getTeamLeaders(team_id,query,status) {
    return this.http.get(`${this.baseUrl}users/get-leaders?team_id=${team_id}&query=${query}&active_status=${status}&page=all&api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getTeamLeadersByID(team_id) {
    return this.http.get(`${this.baseUrl}users/get-leaders?team_id=${team_id}&page=all&api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }

  getAllSeasons(){
     return this.http.get(`${this.baseUrl}seasons/all?api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }

  createSeason(season : Season) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token',this.getToken());
    params.set('name', season.name);
    params.set('enrollment_start_date',season.enrollment_start_date);
    params.set('enrollment_end_date',season.enrollment_end_date);
    params.set('start_date',season.start_date);
    params.set('end_date',season.end_date);
    params.set('season_teams',JSON.stringify(season.season_teams));

    return this.http.post(`${this.baseUrl}seasons/store`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }
  updateSeason(season : Season) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token',this.getToken());
    params.set('name', season.name);
    params.set('enrollment_start_date',season.enrollment_start_date);
    params.set('enrollment_end_date',season.enrollment_end_date);
    params.set('start_date',season.start_date);
    params.set('end_date',season.end_date);
    params.set('season_teams',JSON.stringify(season.season_teams));

    return this.http.put(`${this.baseUrl}seasons/update/${season.id}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }
  getSeasonDetail(season_id){
     return this.http.get(`${this.baseUrl}seasons/get-details/${season_id}?api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  
  deleteSeason(id) {
    return this.http.delete(`${this.baseUrl}seasons/delete/${id}?api_token=${this.getToken()}`, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }
  getAllUpcomingEventsByLeaderID(leader_id) {
    return this.http.get(`${this.baseUrl}events/all?api_token=${this.getToken()}&leader_id=${leader_id}&upcoming_events=1`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getAllUpcomingEventsByUserID(user_id) {
    return this.http.get(`${this.baseUrl}events/all?api_token=${this.getToken()}&user_id=${user_id}&upcoming_events=1`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getAllFutureEventsByLeaderID(leader_id) {
    return this.http.get(`${this.baseUrl}events/all?api_token=${this.getToken()}&leader_id=${leader_id}&future_events=1`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getMessageHistory() {
    return this.http.get(`${this.baseUrl}messaging-log/all?api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getMessagesHistoryPaged(page){
    return this.http.get(`${this.baseUrl}messaging-log/all?page=${page}&api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getDashboardTeamDetails(){
    return this.http.get(`${this.baseUrl}dashboard/get-team-details?api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getDashboardMiles(){
    return this.http.get(`${this.baseUrl}dashboard/get-miles-details?api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getDashboardEvents(){
    return this.http.get(`${this.baseUrl}dashboard/get-events-details?api_token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  
  getUserMessages(user_id, limit){
    console.log(this.getHeaders());
    return this.http.get(`${this.baseUrl}messaging-log/web?api_token=${this.getToken()}&user_id=${user_id}&limit=${limit}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getAllUserMessages(user_id){
    console.log(this.getHeaders());
    return this.http.get(`${this.baseUrl}messaging-log/web?api_token=${this.getToken()}&user_id=${user_id}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getAllUserMessagesPaged(user_id,page){
    return this.http.get(`${this.baseUrl}messaging-log/web?page=${page}&api_token=${this.getToken()}&user_id=${user_id}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  markReadMessage(message_id) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token',this.getToken());
    return this.http.post(`${this.baseUrl}messaging-log/mark-as-read/${message_id}`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }
  getTeamMessages(){
    console.log(this.getHeaders());
    return this.http.get(`${this.baseUrl}team/web-messages?token=${this.getToken()}&limit=3`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getTeamDashboardMiles(){
    return this.http.get(`${this.baseUrl}team/miles?token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  getTeamDashboardEvents(){
    return this.http.get(`${this.baseUrl}team/upcoming-events?token=${this.getToken()}&limit=3`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  searchTeamStudentsByName(term: string): Observable<StudentItem[]> {
    return this.http.get(`${this.baseUrl}team/students?token=${this.getToken()}&query=${term}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => {
        response = response.json();
        console.log(response);
        let dataStud = response['data'];
        console.log("dataStud:",dataStud);
        return dataStud.map(item => {
          return new StudentItem(
            item.first_name,
            item.last_name,
            item.user_id,
            item.id,
            item.team,
            item.email,
            item.first_last_name = item.first_name + " " + item.last_name,
            item.miles_run = item.miles  
          );
        });
      })
    .catch((error:any) => Observable.throw(error.json()));
  }
  getTeamDashboardEventStudents(id){
    return this.http.get(`${this.baseUrl}team/event-students/${id}?token=${this.getToken()}`, { headers: this.getHeaders() })
    .retry(3)
    .map((response: Response) => response.json())
    .catch((error:any) => Observable.throw(error.json()));
  }
  
}  


// WEBPACK FOOTER //
// ./src/app/_services/api.service.ts